export function hasCompleteProfileName(profile: { firstName?: string | null; lastName?: string | null }): boolean {
  return !!profile.firstName?.trim() && !!profile.lastName?.trim();
}
